import React, { useState } from "react";
import moment from "moment";
import "../style/debtDetails.css";

export const DebtPayOffListing = (props) => {
  console.log("lisiting data", props);

  return (
    <div>
      <div className="cardHeadingDebt">Listing</div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          height: "15rem",
        }}
      >
        {props.data && props.data.length > 0 ? (
          <div
            className="ContactTableConatier"
            style={{ height: "15rem", marginTop: "8px" }}
          >
            <div>
              <table className="ContactTable">
                <thead>
                  <tr className="ContactTable-Row">
                    <th className="ContactTable-data">Month</th>
                    <th className="ContactTable-data">Payment</th>
                    <th className="ContactTable-data">Principal</th>
                    <th className="ContactTable-data">Interest</th>
                    <th className="ContactTable-data">Remaining</th>
                  </tr>
                </thead>
                <tbody className="ContactTable-body">
                  {props.data &&
                    props.data.map((data, index) => (
                      <tr key={index} className="ContactTable-Row">
                        <td className="ContactTable-data">
                          {data.month
                            ? moment(data.month).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {props.monthlyPayment ? props.monthlyPayment : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.principalPaid ? data.principalPaid : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.interestPayment ? data.interestPayment : "N/A"}
                        </td>
                        <td className="ContactTable-data">
                          {data.remainingBalance
                            ? data.remainingBalance
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection: "column",
            }}
          >
            No data to show
          </div>
        )}
      </div>
    </div>
  );
};
